document.querySelectorAll('.video-item').forEach(e=> {
    e.addEventListener('click', function() {
        var url = e.dataset.vidUrl;
        var id = e.dataset.vidId;

        var video_pop = document.getElementById('modal-video')
        var iframe = `<div class="video-embed">
            <iframe width="1122" height="631" src="https://www.youtube.com/embed/${id}" frameborder="0" 
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" 
                allowfullscreen>
            </iframe>
        </div>`;

        video_pop.querySelector('.modal_content').innerHTML = '';
        video_pop.querySelector('.modal_content').innerHTML = iframe;

        video_pop.classList.add('is-open')
    })
})

if (document.querySelector('.video-modal-close') != null) {
    document.querySelector('.video-modal-close').addEventListener('click', function() {
        var video_pop = document.getElementById('modal-video')
        video_pop.classList.remove('is-open')
        video_pop.querySelector('.modal_content').innerHTML = '';
    })
}

if ( document.querySelector('input#agree') != null ) {
    document.querySelector('input#agree').addEventListener('click', function() {

        var button = document.querySelector('.form-wrapper [type="submit"]')
    
        if (this.checked) {
            button.removeAttribute('disabled')
        } else {
            button.setAttribute('disabled', true)
        }
    })
}

